import { SchemaTransformerDefinition } from './SchemaDefinition'
import { TransformerDefinition } from './TypedDefinition'
import { TransformerNode } from './TypedNode'
import { TransformerModel } from './ViewModel'

import type { PluginVisitors, RehajePlugin } from '@rehaje/core'

export interface TransformerPluginProps {}

export class TransformerPlugin implements RehajePlugin {
  props: TransformerPluginProps

  visitors?: PluginVisitors = {
    definitions: {
      'Schema.Transformer': SchemaTransformerDefinition,
      Transformer: TransformerDefinition
    },
    models: {
      Transformer: TransformerModel
    },
    nodes: {
      Transformer: TransformerNode
    }
  }

  constructor(props?: TransformerPluginProps) {
    this.props = { ...props }
  }
}
